import { render, staticRenderFns } from "./PartnerHistory.vue?vue&type=template&id=ca9d2b5c&scoped=true&"
import script from "./PartnerHistory.vue?vue&type=script&lang=ts&"
export * from "./PartnerHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerHistory.vue?vue&type=style&index=0&id=ca9d2b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d2b5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
